import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { compose } from 'recompose'

import Enhancer from './ErrorLoggerEnhancer'

class ErrorLogger extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    sendError: PropTypes.func.isRequired,
  }

  componentDidCatch(error, info) {
    const { sendError } = this.props

    sendError({ error, info })
  }

  render() {
    return <div>{this.props.children}</div>
  }
}

const composed = compose(Enhancer)

export default composed(ErrorLogger)
